import { KYMW1400Model } from '../kymw1400.model';
import { LockKomaEditModel } from '../vo/lock-koma-edit.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * ページ情報を取得する
 *
 * @export
 * @class LockKomaEditService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class LockKomaEditService extends PlessJsonResponderSub<any> {

  /** 処理に使用するModel */
  private model: KYMW1400Model = null;
  private vo: LockKomaEditModel = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof LockKomaEditService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode,
        MediumType: this.vo.mediumType,
        CoopCode: this.vo.coopCode,
        PageID: this.vo.pageID,
        PageNum: this.vo.pageNum
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1400Model} model モデルクラス
   * @param {LockKomaEditModel} vo パラメータ
   * @memberof LockKomaEditService
   */
  execute(model: KYMW1400Model, vo: LockKomaEditModel) {
    this.model = model;
    this.vo = vo;
    this.send('KYMW14lockKomaEdit', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} _ レスポンスデータ
   * @memberof LockKomaEditService
   */
  success(_: any) {
    if (this.model.leftPageSelected) {
      this.model.leftView.checkPageLock();
    } else {
      this.model.rightView.checkPageLock();
    }
  }

  /**
   * API通信失敗時の処理
   *
   * @param {*} errList
   * @memberof LockKomaEditService
   */
  public plessErrorHandler(errList: any): void {
    // ロックボタンを元に戻す
    this.model.selectedPageViewHelper.setLockButtonStyle(false);
    // 標準処理を続行
    super.plessErrorHandler(errList);
  }
}
